import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import createRootReducer from '../Redux/reducers/index';

const clearClientListOnLogout = (state) => {
  if (state && state.user && !state.user.isLoggedIn) {
    return {};
  }
  return state;
};

// blacklist filter
const saveSubsetBlacklistFilter = createBlacklistFilter(
  'form',
  ['tempEdge'],
  ['CreateNewAgency', 'CreateNewUser', 'CreateNewClient', 'NewEmployee']
);

// redux-persist config
const persistConfig = {
  key: 'root',
  storage: storageSession,
  transforms: [saveSubsetBlacklistFilter],
  stateReconciler: (inboundState, originalState) => {
    if (inboundState) return { ...originalState, ...clearClientListOnLogout(inboundState) };
    return originalState;
  }
};

// redux-first-history setup
export const browserHistory = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history: browserHistory });

const persistedReducer = persistReducer(persistConfig, createRootReducer(routerReducer));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false // para evitar advertencias con redux-persist
    }).concat(routerMiddleware)
});

export const history = createReduxHistory(store);
export const persistor = persistStore(store);
